import { render, staticRenderFns } from "./Create-New-Sell.vue?vue&type=template&id=f4513972&scoped=true"
import script from "./Create-New-Sell.vue?vue&type=script&lang=js"
export * from "./Create-New-Sell.vue?vue&type=script&lang=js"
import style0 from "./Create-New-Sell.vue?vue&type=style&index=0&id=f4513972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4513972",
  null
  
)

export default component.exports